import Axios from '../axios';
import appConfig from '../../../app.config';
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError } from '../../../shared';
import { IAgreementHistoryDto } from '../../interfaces/i-api-creaditCard'

async function getAgreementHistoryService(t: TFunction) {
    let response = await Axios
        .get<IAgreementHistoryDto>(
            `${appConfig.customerDataBaseUrl}/api/creditcard/agreements`,
            await getHeadersWithJwtToken()
        )
        .then((data) => {
            return data.data as IAgreementHistoryDto
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                throw new Error(t('NoAccounts'))
            } else {
                throw err
            }
        })
    return response as IAgreementHistoryDto
}

export default getAgreementHistoryService;